import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      question: 'How is RenoNovo different from other lead generation companies?',
      answer: 'Unlike traditional lead gen companies that sell the same lead to multiple contractors, we operate on an exclusive territory model. Your service area is yours alone — no shared leads, no bidding wars. Plus, you only pay for actual booked appointments, not just leads or calls.',
    },
    {
      question: 'What types of contractors do you work with?',
      answer: 'We specialize in home service contractors including pool builders, kitchen and bathroom remodelers, roofers, HVAC technicians, flooring/tile installers, backyard renovation specialists, and general contractors. If you serve homeowners, we can help you grow.',
    },
    {
      question: 'How much does it cost per appointment?',
      answer: 'Appointment costs vary based on your industry, service area, and project type. We work with you to establish pricing that ensures a strong ROI for your business. Most contractors see a 3-5x return on their investment with us.',
    },
    {
      question: 'How quickly can I start receiving appointments?',
      answer: 'Most contractors start receiving appointments within 1-2 weeks of launching. We use rapid deployment strategies to get your campaigns live quickly while maintaining our quality standards.',
    },
    {
      question: 'What happens if an appointment doesn\'t show or isn\'t qualified?',
      answer: 'We stand behind our quality guarantee. If an appointment no-shows without rescheduling, or if the lead clearly doesn\'t meet the qualification criteria we agreed upon, you won\'t be charged for that appointment.',
    },
    {
      question: 'Do I need to sign a long-term contract?',
      answer: 'No. We operate on a month-to-month basis because we believe in earning your business through results. Many of our contractors have been with us for years because we consistently deliver value, not because they\'re locked in.',
    },
    {
      question: 'How do you generate the appointments?',
      answer: 'We use a combination of targeted digital advertising, SEO, and direct response marketing to reach homeowners actively searching for services like yours. Our team handles everything from ad creation to lead qualification to appointment scheduling.',
    },
    {
      question: 'What geographic areas do you cover?',
      answer: 'We work with contractors across the United States. Whether you serve a single city, multiple counties, or an entire state, we can target your specific service area with precision.',
    },
  ];

  return (
    <section className="py-20 md:py-32 bg-[#f8fafc]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-sm tracking-wide uppercase font-semibold text-[#2563eb] mb-4">
            Frequently Asked Questions
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f172a] tracking-tight mb-6">
            Got Questions? We've Got Answers.
          </h2>
          <p className="text-lg text-[#64748b] leading-relaxed">
            Everything you need to know about partnering with RenoNovo.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white border border-[#e2e8f0] rounded-sm px-6 data-[state=open]:border-[#2563eb]/30"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="text-left text-[#0f172a] font-semibold hover:text-[#2563eb] py-5 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[#64748b] pb-5 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional CTA */}
        <div className="mt-12 text-center">
          <p className="text-[#64748b] mb-2">Still have questions?</p>
          <a 
            href="/contact" 
            className="text-[#2563eb] font-semibold hover:underline"
            data-testid="faq-contact-link"
          >
            Get in touch with our team
          </a>
        </div>
      </div>
    </section>
  );
};
